import { string, bool, object, func, number } from 'prop-types'
import * as Higgs from '@opallabs/higgs'
import { Modal, Loader, Conditional } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'
import ConnectedAnnotationEditor from '../AnnotationEditor/connectedComponent'
import LayerHeader from './LayerHeader'
import './styles.scss'

const AnnotationLayer = ({
  avatarVisible,
  channelName,
  currentUser,
  createdByUser,
  hideSupportButtons,
  isLatest,
  loader,
  onClose,
  onLatestClick,
  onLifesaverClick,
  postTitle,
  readOnly,
  snapshot,
  snapshotCreatedAt,
  snapshotId,
  showAnnotation,
  userTimezone,
  viewContext,
  visible,
}) => (
  <AnalyticsLayer name="Annotations">
    <Modal
      classes={['annotation-layer']}
      onClose={onClose}
      visible={visible}
      headerContents={
        <LayerHeader
          avatarVisible={avatarVisible}
          channelName={channelName}
          createdByUser={createdByUser}
          hideSupportButtons={hideSupportButtons}
          isLatest={isLatest}
          onClose={onClose}
          onLatestClick={onLatestClick}
          onLifesaverClick={onLifesaverClick}
          postTitle={postTitle}
          snapshotCreatedAt={snapshotCreatedAt}
          theme="dark"
          viewContext={viewContext}
        />
      }
    >
      <Conditional condition={!loader}>
        <Higgs.Provider>
          <ConnectedAnnotationEditor
            currentUser={currentUser}
            readOnly={readOnly}
            showAnnotation={showAnnotation}
            snapshot={snapshot}
            snapshotId={snapshotId}
            userTimezone={userTimezone}
          />
        </Higgs.Provider>
      </Conditional>
      <Loader loaded={!loader} theme="n1" />
    </Modal>
  </AnalyticsLayer>
)

AnnotationLayer.propTypes = {
  avatarVisible: bool,
  channelName: string,
  createdByUser: object,
  currentUser: object,
  hideSupportButtons: bool,
  isLatest: bool,
  loader: bool,
  onClose: func,
  onLatestClick: func,
  onLifesaverClick: func,
  postTitle: string,
  readOnly: bool,
  showAnnotation: string,
  snapshot: string,
  snapshotCreatedAt: string,
  snapshotId: number,
  userTimezone: string,
  viewContext: string,
  visible: bool,
}

export default AnnotationLayer
